module.exports = __webpack_public_path__ + "static/rooms03-34d54559d748f3a2ffdffb53102f67b2.jpg";